import {
  SET_GET_PRODUCT_REQUEST,
  SET_GET_PRODUCT_SUCCESS,
  SET_GET_PRODUCT_FAILED,
  SET_GET_GIFT_REQUEST,
  SET_GET_GIFT_SUCCESS,
  SET_GET_GIFT_FAILED,
  SET_GET_LIST_REQUEST,
  SET_GET_LIST_SUCCESS,
  SET_GET_LIST_FAILED,
  SET_GET_DETAIL_REQUEST,
  SET_GET_DETAIL_SUCCESS,
  SET_GET_DETAIL_FAILED,
  SET_GET_CAMPAIGN_TYPE_SUCCESS,
  SET_GET_CAMPAIGN_TYPE_FAILED,
  SET_UPDATE_GWP_REQUEST,
  SET_UPDATE_GWP_SUCCESS,
  SET_UPDATE_GWP_FAILED,
  SET_UPDATE_GWP_STATUS_FAILED,
  SET_CREATE_GWP_REQUEST,
  SET_CREATE_GWP_SUCCESS,
  SET_CREATE_GWP_FAILED,
  SET_SELECT_PRODUCT_FOR_CREATE_GWP,
  SET_SELECT_GIFT_FOR_CREATE_GWP,
  SET_UPDATE_GIFT,
  SET_CREATE_GIFT,
  SET_PAGINATION_PRODUCT,
  SET_DELETE_GIFT,
  SET_GWP_FORM,
  SET_GWP_RESET,
  SET_GWP_LOADING,
  SET_GWP_PARAMS_FILTER,
} from 'storeContext/actionsType/gwp'
import type { GwpCampaignTypeItemType, GwpProductListItemType } from 'utils/apiList/gwp'

export interface GwpCampaignListItemType {
  checked: boolean
  key: string
  name: string
  campaignType?: unknown
  campaign_type?: string
  childs: unknown[]
}

export interface GwpGiftHubType {
  is_active: boolean
  location_hub_id: number | string
  location_hub_name?: string
  quota: number | string
  stock: number | string
}

export interface GwpGiftItemType {
  product_id: number | string
  product_name: string
  product_price?: number | string
  product_sku_number?: string
  sku_number?: string
  product_image_url?: string
  gwp_detail_location_hub: GwpGiftHubType[]
}

export interface GwpFormType {
  campaign_list: GwpCampaignListItemType[]
  campaign: string[]
  skuRelated: (number | string)[]
  gift: GwpGiftItemType[]
  giftForCreateGwp: GwpGiftItemType[]
  campaign_name: string
  start_date: string
  start_time: string
  end_date: string
  end_time: string
  is_active: boolean
  is_all_day: boolean
  minimum_buy_total: string | number
  limit_user_per_campaign: string | number
  detail_toc: string
  link: string
  gwp_type: string
  is_targeted: boolean
  is_shown: boolean
  targeting_type: string
  segment_id: number | null
  segment_name: string
  is_new_user: boolean
}

export interface GwpParamsFilterType {
  search: string
  gwpType: string
  isActive: string
  startDate: number
  endDate: number
  pageIndex: number
  orderBy: string
  orderDirection: string
}

export interface GwpPaginationType {
  first: number
  last: number
}

export interface GwpRuleType {
  campaign_type: string
  value_type: string | number
}

export interface GwpSkuRelatedType {
  id: string | number
}

export interface GwpProductQuotaType {
  sku_number?: string
  [key: string]: unknown
}

export interface GwpDetailType {
  gwp_rules: GwpRuleType[]
  gwp_sku_related: GwpSkuRelatedType[]
  gwp_product_quotas: GwpProductQuotaType[]
  campaign_name?: string
  is_active?: boolean
  is_all_day?: boolean
  start_date?: string
  start_time?: string
  end_date?: string
  end_time?: string
  link?: string
  detail_toc?: string
  gwp_type?: string
  is_targeted?: boolean
  is_shown?: boolean
  targeting_type?: string
  segment_id?: number | null
  segment_name?: string
  is_new_user?: boolean
  minimum_buy_total?: string | number
  limit_user_per_campaign?: string | number
}

export interface GwpCampaignTypeStateType {
  data: GwpCampaignTypeItemType[]
}

export interface GwpStateType {
  isLoading: boolean
  product: GwpProductListItemType[]
  gift: GwpProductListItemType[]
  list: unknown[]
  productDetail: GwpDetailType
  campaignType: GwpCampaignTypeStateType
  productForCreateGwp: (number | string)[]
  formGwp: GwpFormType
  giftForCreateGwp: GwpGiftItemType[]
  paginationProduct: GwpPaginationType | null
  paramsFilter: GwpParamsFilterType
  dropdownGwpType: { id: string; name: string }[]
  dropdownStatus: { id: string; name: string }[]
}

type GwpActionType = {
  type: string
  payload?: unknown
}

export const initialStateGwp: GwpStateType = {
  isLoading: false,
  product: [],
  gift: [],
  list: [],
  productDetail: {} as GwpDetailType,
  campaignType: [] as unknown as GwpCampaignTypeStateType,
  productForCreateGwp: [],
  formGwp: {
    campaign_list: [],
    campaign: [],
    skuRelated: [],
    gift: [],
    giftForCreateGwp: [],
    campaign_name: '',
    start_date: '',
    start_time: '',
    end_date: '',
    end_time: '',
    is_active: false,
    is_all_day: false,
    minimum_buy_total: '',
    limit_user_per_campaign: '',
    detail_toc: '',
    link: '',
    gwp_type: '',
    is_targeted: false,
    is_shown: false,
    targeting_type: '',
    segment_id: null,
    segment_name: '',
    is_new_user: false,
  },
  giftForCreateGwp: [],
  paginationProduct: null,
  paramsFilter: {
    search: '',
    gwpType: '',
    isActive: '',
    startDate: 0,
    endDate: 0,
    pageIndex: 1,
    orderBy: 'created_at',
    orderDirection: 'DESC',
  },
  dropdownGwpType: [
    { id: 'BAU', name: 'BAU' },
    { id: 'Flush Out', name: 'Flush Out' },
    { id: 'Exclusive Launch', name: 'Exclusive Launch' },
    { id: 'Virtual Bundling', name: 'Virtual Bundling' },
    { id: 'Grab Mart', name: 'Grab Mart' },
  ],
  dropdownStatus: [
    { id: 'true', name: 'Aktif' },
    { id: 'false', name: 'Tidak Aktif' },
  ],
}

export default function gwpReducer(
  state: GwpStateType = initialStateGwp,
  { type, payload }: GwpActionType,
) {
  switch (type) {
    case SET_PAGINATION_PRODUCT:
      return {
        ...state,
        isLoading: false,
        paginationProduct: payload as GwpPaginationType,
      }

    case SET_CREATE_GIFT:
      return {
        ...state,
        isLoading: false,
        giftForCreateGwp: payload as GwpGiftItemType[],
      }

    case SET_DELETE_GIFT:
      return {
        ...state,
        isLoading: false,
        giftForCreateGwp: [
          {
            ...state.giftForCreateGwp[0],
            gwp_detail_location_hub: [],
          },
        ],
      }

    case SET_UPDATE_GIFT:
      return {
        ...state,
        isLoading: true,
        giftForCreateGwp: [
          {
            ...state.giftForCreateGwp[0],
            gwp_detail_location_hub: payload,
          },
        ],
      }

    case SET_GET_PRODUCT_REQUEST:
    case SET_GET_GIFT_REQUEST:
    case SET_GET_LIST_REQUEST:
    case SET_GET_DETAIL_REQUEST:
    case SET_UPDATE_GWP_REQUEST:
    case SET_CREATE_GWP_REQUEST:
      return {
        ...state,
        isLoading: true,
      }

    case SET_GET_PRODUCT_FAILED:
    case SET_GET_GIFT_FAILED:
    case SET_GET_LIST_FAILED:
    case SET_GET_DETAIL_FAILED:
    case SET_GET_CAMPAIGN_TYPE_FAILED:
    case SET_UPDATE_GWP_FAILED:
    case SET_UPDATE_GWP_STATUS_FAILED:
    case SET_CREATE_GWP_FAILED:
    case SET_UPDATE_GWP_SUCCESS:
    case SET_CREATE_GWP_SUCCESS:
      return {
        ...state,
        isLoading: false,
      }

    case SET_SELECT_PRODUCT_FOR_CREATE_GWP:
      return {
        ...state,
        productForCreateGwp: state.productForCreateGwp.push(
          payload as number | string,
        ) as unknown as (number | string)[],
      }

    case SET_SELECT_GIFT_FOR_CREATE_GWP:
      return {
        ...state,
        giftForCreateGwp: state.giftForCreateGwp.push(
          payload as GwpGiftItemType,
        ) as unknown as GwpGiftItemType[],
      }

    case SET_GET_PRODUCT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        product: payload as GwpProductListItemType[],
      }

    case SET_GET_GIFT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        gift: payload as GwpProductListItemType[],
      }
    case SET_GET_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        list: payload as unknown[],
      }
    case SET_GET_DETAIL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        productDetail: payload as GwpDetailType,
      }
    case SET_GET_CAMPAIGN_TYPE_SUCCESS:
      return {
        ...state,
        campaignType: payload as GwpCampaignTypeStateType,
      }
    case SET_GWP_FORM:
      return {
        ...state,
        formGwp: {
          ...state.formGwp,
          ...(payload as Partial<GwpFormType>),
        },
      }
    case SET_GWP_LOADING:
      return { ...state, isLoading: payload as boolean }

    case SET_GWP_RESET:
      return initialStateGwp

    case SET_GWP_PARAMS_FILTER:
      return {
        ...state,
        paramsFilter: payload as GwpParamsFilterType,
      }

    default:
      return {
        ...state,
      }
  }
}
